module.exports = __webpack_public_path__ + "media/img/frontend_application/notification/venue_owner/enquiry_accepted-2341d963b0e3a14035ad17c36e2fbb7a.png";